// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1t7n8","question":"Question_question__jBhBT","description":"Question_description__15uV6"};